"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const ChallengeType_1 = require("../enums/ChallengeType");
exports.default = vue_1.default.extend({
    name: 'forgotpassword',
    props: {},
    computed: {
        currentChallengeType() {
            const challengeType = this.$store.getters.currentChallengeType;
            switch (challengeType) {
                case ChallengeType_1.ChallengeType.StepUp:
                    return ChallengeType_1.ChallengeType.StepUpForgot;
                case ChallengeType_1.ChallengeType.OneTimeCode:
                    return ChallengeType_1.ChallengeType.OneTimeCodeForgotContainer;
                case ChallengeType_1.ChallengeType.CheckSyncResult:
                    return ChallengeType_1.ChallengeType.CheckSyncResultForgot;
                default:
                    return challengeType;
            }
        },
    },
    methods: {
        submitForm(event) {
            void this.$store.dispatch('submitChallenge', this.$store.state.currentChallenge);
            event.preventDefault();
        },
    },
    components: {},
    mounted() {
        this.$store.commit('currentChallenge', {
            ChallengeTypeValue: this.$store.getters.configuration.initialChallengeType,
            Progression: [],
        });
        void this.$store.dispatch('submitChallenge', this.$store.state.currentChallenge);
    },
});
